export default __webpack_public_path__ + "images/6f18495b98f9709144eac621b352bfcc-cultural_music.webp";